export default "__VITE_ASSET__CI$bORA$__"